import React, { useRef } from 'react'
import { useInfo } from '../context/useInfo';
import LoginInput from '../components/inputs/LoginInput';
import { useLoaderData, useLocation } from 'react-router';
import { useEnvironment } from '../context/useEnv';

function Login() {
    const environment = useEnvironment();
    const { info, fetchLogin } = useInfo();
    const location = useLocation();

    if (!environment.DEV || true) {
        const redirectLink = `https://accounts.angeldav.net/?continue=${encodeURIComponent(environment.HREF)}&next=${encodeURIComponent(`${new URL(environment.HREF).origin}/login`)}`
        return <>
            <p>Redirecting to account management..</p>
            <a className='text-primary'
                href={redirectLink}
            >Click here if the automatic redirect doesn't work</a>
            <meta http-equiv="refresh" content={`0; url=${redirectLink}`} />
        </>
    }

    const usernameRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    async function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (usernameRef.current == null || passwordRef.current == null) return

        const loginResponse = await fetchLogin(usernameRef.current.value, passwordRef.current.value)

        usernameRef.current.value = ""
        passwordRef.current.value = ""
    }

    return <article className='pt-4 flex flex-wrap justify-between items-stretch'>
        <section className='p-4 max-w-md m-auto mb-8'>
            <img className='size-full max-w-48 max-h-48 aspect-square' src="/images/account.png" alt="Account icon" />
            <p className='font-semibold text-4xl'>Login required to continue</p>
        </section>
        <form action="/login" method='GET' onSubmit={onSubmit} className='flex-grow max-w-md flex flex-col gap-2 justify-center m-auto'>
            <LoginInput
                required
                ref={usernameRef}
                title="Username"
                placeholder='bob'
                autocomplete='username'
            />
            <LoginInput
                required
                ref={passwordRef}
                type='password'
                title="Password"
                placeholder='**********'
                autocomplete='current-password'
            />
            <input style={{ display: "none" }} type="text" name='location' defaultValue={location.pathname} />
            <a target='blank' href="https://angeldav.net/signin" className='text-primary font-semibold italic'>I don't have an account</a>
            <button type="submit" className='text-center w-full bg-primary p-2 rounded-xl font-semibold text-white'>Submit</button>
        </form>
    </article>
}

export default Login